import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Define the types for the state
export interface SystemState {
  isGameCreationInProgress: boolean
  isLoading: boolean
  imageLoaderKeys: string[] // Assuming this will be an array of strings
  previewMode: boolean
  imageEditorOpen: boolean
  soundEditorOpen: boolean
  deleteModal: { id: string; show: boolean }
}

// Define the initial state with types
const initialState: SystemState = {
  isGameCreationInProgress: false,
  isLoading: false,
  imageLoaderKeys: [],
  previewMode: false,
  imageEditorOpen: false,
  soundEditorOpen: false,
  deleteModal: { id: '', show: false },
}

// Create the slice with properly typed reducers
export const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    updateGameCreationInProgress: (state, action: PayloadAction<boolean>) => {
      state.isGameCreationInProgress = action.payload
    },
    updateImageLoaderKeys: (state, action: PayloadAction<string[]>) => {
      state.imageLoaderKeys = action.payload
    },
    updateIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    updatePreviewMode: (state, action: PayloadAction<boolean>) => {
      state.previewMode = action.payload
    },
    toggleImageEditor: (state, action: PayloadAction<boolean>) => {
      state.imageEditorOpen = action.payload
    },
    toggleSoundEditor: (state, action: PayloadAction<boolean>) => {
      state.soundEditorOpen = action.payload
    },
    toggleGameDelete: (
      state,
      action: PayloadAction<SystemState['deleteModal']>
    ) => {
      state.deleteModal = action.payload
    },
  },
})

// Export the actions for use in components
export const {
  updateIsLoading,
  toggleGameDelete,
  updatePreviewMode,
  toggleImageEditor,
  toggleSoundEditor,
  updateImageLoaderKeys,
  updateGameCreationInProgress,
} = systemSlice.actions

// Export the reducer to be used in the store
export default systemSlice.reducer
